import React from 'react';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import Theme from './utils/theme';
import GlobalStyle from './utils/theme/globalStyles';
import Store from './redux-flow/index.store';
import Routes from './routes';

const App = () => (
  <Provider store={Store}>
    <ThemeProvider theme={Theme}>
      <>
        <GlobalStyle />
        { Routes() }
      </>
    </ThemeProvider>
  </Provider>
);

export default App;
